import { Component } from 'react';
import ReactDOM from 'react-dom';

var Element = function() {}
Element.prototype = {
    findNote(selector, context) {
        return (context || this.el).querySelectorAll(selector);
    },
    find(selector) {
        let notes = this.findNote(selector) || [];
        if (notes[0]) {
            return dom(notes[0]);
        }
    },
    css(name, val) {
        if (!name) return;

        var el = this.el;
        if (typeof name === 'object') {
            for (var k in name) {
                el.style[k] = name[k];
            }
        } else if (val === undefined) {
            val = (window.getComputedStyle ? window.getComputedStyle(el, null) : el.currentStyle)[name] || "";
            if (val === "auto") return 0;
            if (val.slice(val.length - 2) === "px") {
                var _val = parseFloat(val);
                return !isNaN(_val) ? _val : val;
            }
            return val;
        } else {
            el.style[name] = val;
        }
        return this;
    },
    attr(name, val) {
        let el = this.el;
        if (val === undefined)
            return el[name] || el.getAttribute(name);
        el[name] = val;
    },
    show(type) {
        return this.css('display', type || 'block');
    },
    hide() {
        return this.css('display', 'none');
    },
    html(val) {
        return this.attr("innerHTML", val) || "";
    },
    val(val) {
        return this.attr("value", val) || "";
    },
    text(content) {
        var el = this.el;
        if (content === undefined) {
            return (typeof el.textContent === "string") ? el.textContent : el.innerText;
        }
        if (typeof el.textContent === "string") {
            el.textContent = content;
        } else {
            el.innerText = content;
        }
        return this;
    },
    is(selector) {
        if (!selector) return false;

        var el = this.el;
        var sign = selector.charAt(0);

        if (el === selector) return true;
        switch (sign) {
            case "#":
                return sign + el.id === selector;
            case ".":
                selector = selector.slice(1);
                return this.hasClass(selector);
            default:
                return el.tagName.toLowerCase() === selector.toLowerCase();
        }
        return false;
    },
    hasClass(clz) {
        var el = this.el;
        return el ? new RegExp("\\b" + clz + "\\b").test(el.className) : false;
    },
    addClass(clz) {
        var el = this.el;
        if (!this.hasClass(clz)) {
            el.className += " " + clz;
        }
        return this;
    },
    removeClass(clz) {
        var el = this.el;
        let pattern = new RegExp("\\b" + clz + "\\b");
        if (this.hasClass(clz)) {
            el.className = el.className.replace(pattern, '');
        }
        return this;
    },
    // movePos(index) {
    //     let el = this.el;
    //     el.focus();
    //     var len = el.value.length;
    //     (index == "start") && (index = 0);
    //     if (index >= 0) {
    //         len = index + 1;
    //     }
    //     if (document.selection) {
    //         var sel = el.createTextRange();
    //         sel.moveStart('character', len);
    //         sel.collapse();
    //         sel.select();
    //     } else if (typeof el.selectionStart == 'number' && typeof el.selectionEnd == 'number') {
    //         el.selectionStart = el.selectionEnd = len;
    //     }
    // }
}

export function dom(selector) {
    let el = selector;
    if (selector instanceof Component) {
        el = ReactDOM.findDOMNode(selector);
    }
    var element = new Element();
    element.el = el;
    element[0] = el;
    return element;
}


// WEBPACK FOOTER //
// ./src/utils/dom.js